<template>
    <div :item="socketMessage" style="cursor:pointer;color:#409EFF;z-index:9999;position:fixed;bottom:10px;right:10px;width:150px;background:#fff;border:1px solid #dedede;padding:1rem 1rem;" v-if="showMessage" @click="checkMessage">
      您有一条未读消息！
    </div>
</template>

<script>
  import {mapGetters} from "vuex";
import {getMessageList,getMessageDetail} from "@/api/message/message";
export default {
    data() {
      // let userId = this.userInfo.user_id;
      // console.log(this.userInfo.user_id);
      return {
        socketMessage:'',
        showMessage:false,
        wsMsg:'',
        path:``,
            socket:"",
        activeNames: ['1', '2', '3', '5'],
        logActiveNames: ['17']
      };
    },
    mounted () {
        // 初始化
        // this.init()
        if(this.userInfo){

          this.wsConnectHandler();
        }
    },
    destroyed () {
        // 销毁监听
        this.socket.onclose = this.close
    },
    computed: {
      ...mapGetters(["userInfo"]),
    },
    methods: {
      checkMessage(e){
        this.showMessage = false;
        // getMessageDetail({
        //     messageType:this.socketMessage.messageType,
        //     messageRemark:this.socketMessage.messageRemark,
        //     readFlag:this.socketMessage.readFlag,
        //     id:this.socketMessage.id
        // }).then((res)=>{
        //   this.$router.push({ path: res.data.data });
        //   console.log(this.socketMessage);
        // });
      },
      wsConnectHandler(){
        this.init()
      },
      sendMsg(){

        this.send(this.wsMsg);
      },
              init: function () {
                this.path = 'ws://'+window.location.host+`/ws/v4ward/websocket/example?userId=${this.userInfo.user_id}`;
                // this.path = `ws://localhost:1888/ws/v4ward/websocket/example?userId=${this.userInfo.user_id}`;
            if(typeof(WebSocket) === "undefined"){
                alert("您的浏览器不支持socket")
            }else{
                // 实例化socket
                this.socket = new WebSocket(this.path)
                // 监听socket连接
                this.socket.onopen = this.open
                // 监听socket错误信息
                this.socket.onerror = this.error
                // 监听socket消息
                this.socket.onmessage = this.getMessage
            }
        },
        open: function () {
            console.log("socket连接成功")
        },
        error: function () {
            console.log("连接错误")
        },
        getMessage: function (msg) {
          this.showMessage = true;
          this.socketMessage = msg.data;
            console.log(msg.data)
        },
        send: function (params) {
            this.socket.send(params)
        },
        close: function () {
            console.log("socket已经关闭")
        },
      handleChange(val) {
        window.console.log(val);
      }
    },
}
</script>

<style>

</style>